import { create } from 'zustand';
import type { ProductDto } from '@/types/dtos/orders/response/product.dto.ts';

interface ProductState {
  products?: ProductDto[];
  setProducts: (change: ProductDto[]) => void;
}

export const useProductsStore = create<ProductState>()((set) => ({
  products: undefined,
  setProducts: (change) => set(() => ({ products: change })),
}));
